import { useDispatch, useSelector, useStore } from 'react-redux';
import type { AppDispatch, AppStore, RootState } from './store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<AppStore>();

/**
 * Stable empty array for `useAppSelector` fallbacks.
 *
 * `(state) => state.x?.list ?? []` mints a NEW `[]` on every call while the
 * slice is unset, so react-redux's dev check ("Selector … returned a
 * different result when called with the same parameters") fires and the
 * component re-renders on every store update. Returning this shared, frozen
 * instance keeps the selector referentially stable. Typed as `readonly
 * never[]` so it is assignable to any `readonly T[]` without a cast.
 */
export const EMPTY_ARRAY: readonly never[] = Object.freeze([]);
